// extracted by mini-css-extract-plugin
module.exports = {"table":"dynamictable_table__xLpzj","row":"dynamictable_row__LWRVA","label":"dynamictable_label__U7tSc","cell":"dynamictable_cell__D_ofF"};